import { render, staticRenderFns } from "./UpdateStockModal.vue?vue&type=template&id=02d7c220"
import script from "./UpdateStockModal.vue?vue&type=script&lang=js"
export * from "./UpdateStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports